var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"aria-label":_vm.caption,"to":_vm.link}},[_c('b-icon',{attrs:{"icon":_vm.icon}}),_c('span',{staticClass:"sidebar-hidden-closed"},[_vm._v(_vm._s(_vm.caption))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }